export default __webpack_public_path__ + "static/media/intro_right_image.69586a7a.png";